import { Component, OnInit } from '@angular/core';
import { MdDialogRef } from '@angular/material';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss']
})
export class AddUserComponent implements OnInit {
  public createUserForm: FormGroup;

  constructor(public dialogRef: MdDialogRef<AddUserComponent>,
              private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.createUserForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      role: ['', Validators.required]
    });
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onSaveClick(customerData) {
    this.dialogRef.close(customerData);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/admin/shared/add-user/add-user.component.ts